<!--
 * @Author: DQL
 * @Date: 22022-08-04 16:27:47
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 11:46:14
 * @Description: 签章管理
-->
<template>
  <div
    v-loading="loading"
    class="l-page l-page--search"
  >
    <!-- 页面头部 Start -->
    <div
      class="l-page__header c-page__header"
    >
      <!-- 页面标题 -->
      <h2
        v-menu-title
        class="c-page__header-title"
      >
        {{ dlTypeStr }}
      </h2>

      <!-- 标题栏按钮区域 Start -->
      <div
        class="c-page__header-btns"
      >
        <k-button
          btn-text="查询"
          :auth-type="false"
          type="primary"
          icon="kestrel-icon ki-search"
          @click="refreshSearch()"
        />
        <k-button
          btn-text="重置"
          :auth-type="false"
          icon="kestrel-icon ki-repeat"
          @click="resetForm()"
        />
        <k-button
          btn-text="导出"
          :auth-type="false"
          type="primary"
          icon="kestrel-icon ki-export"
          plain
          :disabled="page.rows.length<1"
          @click="handleExport()"
        />
      </div>
      <!-- 标题栏按钮区域 End -->
    </div>
    <!-- 页面头部 End -->

    <!-- 查询条件 Start -->
    <div
      class="l-page__item l-page--search__item"
    >
      <hm-page-card
        title="查询条件"
        class="c-card--condition"
      >
        <!-- 查询条件表单 Start -->
        <!-- tips：c-condition__form类用于查询类布局的查询条件模块使用 -->
        <el-form
          ref="filterParams"
          class="c-form c-condition__form"
          :model="filterParams"
          :inline="true"
          label-position="right"
          label-width="100px"
          label-suffix="："
        >
          <el-row
            class="c-form__row"
          >
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="项目名称"
                prop="xmmc"
              >
                <el-input
                  v-model.trim="filterParams.xmmc"
                  class="c-form__input"
                  placeholder="项目名称"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="委托单位"
                prop="wtdw"
              >
                <el-input
                  v-model.trim="filterParams.wtdw"
                  class="c-form__input"
                  placeholder="委托单位"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="项目负责人"
                prop="xmfzrMc"
              >
                <el-input
                  v-model.trim="filterParams.xmfzrMc"
                  class="c-form__input"
                  placeholder="项目负责人"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!-- 查询条件表单 End -->
      </hm-page-card>
    </div>
    <!-- 查询条件 End -->

    <!-- 页面主内容：查询列表 Start -->
    <div
      class="l-page__body l-page--search__body"
    >
      <!-- tips：l-page__tabs--single类用于只有一个tab时修饰页面使用 -->
      <el-tabs
        type="border-card"
        class="l-page__tabs l-page__tabs--single"
      >
        <el-tab-pane
          label="查询结果"
        >
          <!-- table的ref的命名根据业务名称修改 -->
          <k-table
            ref="bgglTable"
            height="100%"
            :table-column="tableColumn"
            :data="page.rows"
            :pagination="page"
            @current-change="search"
            @size-change="handleSizeChange"
          >
            <template
              #xmmc="scope"
            >
              <el-link
                type="primary"
                @click="openNavTab({ name: 'pgxmDetail',params: { id: scope.row.xmId } })"
              >
                {{ scope.row.xmmc }}
              </el-link>
            </template>

            <template
              #bgbh="scope"
            >
              <el-link
                type="primary"
                :disabled="scope.row.previewPdf"
                @click="(e)=>$utils.previewPdf(e,scope.row.bgUrl, scope.row)"
              >
                <i
                  v-show="scope.row.previewPdf"
                  class="el-icon-loading"
                />
                {{ scope.row.bgbh }}
              </el-link>
            </template>
            <!-- <el-table-column
              v-if="dlType=== 'dscbg'"
              prop="enabled"
              label="操作"
              width="220"
              align="center"
              fixed="right"
            >
              <template>
                <k-button
          btn-text="导出"
:auth-type="false"
                  type="success"
                  icon="iconfont icon-baogao"
                >
                  生成报告
                </k-button>
                <k-button
          btn-text="导出"
:auth-type="false"
                  type="success"
                  icon="iconfont icon-baogao"
                >
                  生成临时报告
                </k-button>
              </template>
            </el-table-column> -->
            <!-- <el-table-column
              v-else
              prop="enabled"
              label="操作"
              width="100"
              align="center"
              fixed="right"
            >
              <template
                slot-scope="scope"
              >
                <k-button
          btn-text="导出"
:auth-type="false"
                  type="danger"
                  plain
                  @click="handleDel(scope.row, scope.$index)"
                >
                  作废报告
                </k-button>
              </template>
            </el-table-column> -->
            <el-table-column
              prop="enabled"
              label="操作"
              width="100"
              align="center"
              fixed="right"
            >
              <template
                slot-scope="scope"
              >
                <k-button
                  v-if="scope.row.xmzt === 'DQZ'"
                  v-permission-element="'pgxm_qz'"
                  btn-text="签章"
                  :auth-type="true"
                  type="primary"
                  plain
                  @click="handleQz(scope.row.xmId)"
                />
                <k-button
                  v-if="scope.row.xmzt === 'YQZ' || scope.row.xmzt === 'YGZ'"
                  v-permission-element="'pgxm_sqxg'"
                  btn-text="申请修改"
                  :auth-type="true"
                  type="primary"
                  plain
                  @click="handleDialog('sqxg',{id: scope.row.xmId})"
                />
                <k-button
                  v-if="scope.row.xmzt === 'DGZ'"
                  v-permission-element="'pgxm_gz'"
                  btn-text="加盖公章"
                  :auth-type="true"
                  type="primary"
                  plain
                  @click="handleJggz(scope.row.xmId)"
                />
              </template>
            </el-table-column>
          </k-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 页面主内容：查询列表 End -->

    <!--  -->
    <!-- <details-dialog
      v-if="showDialogName==='details'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="refreshSearch()"
    /> -->
    <!-- 申请修改 -->
    <sqxg-dialog
      v-if="showDialogName === 'sqxg'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="refreshSearch()"
    />
  </div>
</template>

<script>
import { bgglManageService } from './bggl.service.js';
import { pgxmManageService } from '../pgxm/pgxm.service';
import SqxgDialog from '../pgxm/details/SqxgDialog.vue';
export default {
  name: 'Bggl',
  components: {
    SqxgDialog
    // detailsDialog: () => import('./detailsDialog')
  },
  data () {
    return {
      loading: false, // 页面是否loading状态
      /* 查询条件（页面绑定的查询条件） start */
      filterParams: {
        bglx: [],
        bgType: null,
        xmmc: null,
        wtdw: null,
        xmfzrMc: null
      },
      /* 查询条件 end */

      /* 表单校验规则 Start */
      // filterParamsRules: {
      //   zxsjQZ: [this.$HMValidator.dateRange('开始时间')]
      // },
      /* 表单校验规则 End */

      /* 弹窗 start */
      showDialogName: '',
      dialogParams: {},
      /* 弹窗 end */

      /* 分页实际查询条件（避免查询条件的双向绑定导致点击分页按钮，获取到的数据不符合真实过滤条件） Start */
      trueFilterParams: {},
      /* 分页实际查询条件 End */

      /* 导出实际查询条件（避免查询条件的双向绑定导致点击导出按钮，获取到的数据与查询结果不一致） Start */
      exportFilterParams: {},
      /* 导出实际查询条件 End */

      /* 查询结果 Start */
      page: {
        rows: [],
        total: 0,
        pageSize: 15,
        pageNo: 0
      },
      /* 查询结果 End */

      /* 表格列配置Start */
      tableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'xmmc', slotName: 'xmmc', label: '项目名称', align: 'left', minWidth: '120', type: 'text' },
        { key: 'wtdw', label: '委托单位', align: '', minWidth: '150', type: 'text' },
        { key: 'bgbh', slotName: 'bgbh', label: '报告编号', align: 'left', minWidth: '130', type: 'text' },
        { key: 'xmfzrMc', label: '项目负责人', align: 'left', width: '140', type: 'text' },
        // { key: 'lrdw', label: '录入单位', align: 'left', minWidth: '130', type: 'text' },
        { key: 'cjsj', label: '创建时间', align: 'center', minWidth: '130', type: 'dateTime' }
      ]
      /* 表格列配置End */
      // dlType: 'dgz'

    };
  },
  computed: {
    dlType () {
      return this.$route.name;
    },
    dlTypeStr () {
      return this.$route.meta.navtabTitle;
    }
  },
  methods: {
    /**
     * @description: 记录分页查询条件，调用查询方法
     * @return {*}
     */
    refreshSearch () {
      this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
      // [this.trueFilterParams.zxsjq, this.trueFilterParams.zxsjz] = this.trueFilterParams.zxsjQZ;
      this.search();
    },
    /**
     * @description: 查询列表方法
     * @param {number} _pageNo
     * @return {*}
     */
    search (_pageNo = 1) {
      /* 处理分页参数 Start */
      this.trueFilterParams.pageSize = this.page.pageSize;
      this.trueFilterParams.pageNo = _pageNo;
      /* 处理分页参数 End */

      this.loading = true;

      bgglManageService.query(this.trueFilterParams)
        .then(rsp => {
          this.page = Object.assign({}, this.page, rsp.data);

          // 导出条件更新为查询使用的条件
          this.exportFilterParams = JSON.parse(JSON.stringify(this.trueFilterParams));
        })
        .catch(err => {
          console.error('查询错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 分页切换大小
     * @param {number} val
     * @return {*}
     */
    handleSizeChange (val) {
      this.page.pageSize = val;
      this.search();
    },
    /**
     * @description: 重置页面为初始状态
     * @param：
     * @return {*}
     */
    resetForm () {
      this.$refs.filterParams.resetFields();
    },
    /**
       * @description: 跳转到查看
       * @author: cgh
       */
    handleDialog (_name, _params) {
      this.showDialogName = _name;
      this.dialogParams = _params;
    },
    /**
     * @description: 删除
     * @return {*}
     */
    handleDel (_row) {
      const _this = this;
      _this.$confirm('是否确认作废此条报告数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        bgglManageService.delete(_row.id)
          .then(rsp => {
            _this.$alert('删除成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
              }
            });
            _this.search();
          })
          .catch(err => {
            console.error('删除失败！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      }).catch(() => {
      });
    },
    /**
     * @description: 导出业务流程
     * @param {*}
     * @return {*}
     */
    handleExport () {
      this.loading = true;
      bgglManageService.export(this.exportFilterParams)
        .then(rsp => {
          const fileStream = rsp.data;
          const fileName = decodeURIComponent(escape(rsp.headers['content-disposition'].split('=')[1]));
          this.$HMUtil.downloadStreamFile(fileStream, fileName);
        })
        .catch(err => {
          console.error('导出错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 签章
     * @return {*}
     */
    handleQz (_xmId) {
      const _this = this;
      _this.$confirm('是否确认签章？', '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        pgxmManageService.qz(_xmId)
          .then(rsp => {
            _this.$alert('签章成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {

              }
            });
            _this.refreshSearch();
          })
          .catch(err => {
            console.error('签章失败！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      }).catch(() => {
      });
    },
    /**
     * @description: 加盖公章
     * @return {*}
     */
    handleJggz (_xmId) {
      const _this = this;
      _this.$confirm('是否确认加盖公章？', '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        pgxmManageService.jggz(_xmId)
          .then(rsp => {
            _this.$alert('加盖公章成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
              }
            });
            _this.refreshSearch();
          })
          .catch(err => {
            console.error('加盖公章失败！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      }).catch(() => {
      });
    }
  },
  created () {
    const _routerName = this.$route.name;
    this.filterParams.bgType = _routerName.toUpperCase();
    // 所有报告页面添加状态一栏
    if (_routerName === 'xfpgsybg' || _routerName === 'xfpgygz') {
      this.tableColumn.push({ key: 'xmztMc', label: '状态', align: 'left', minWidth: '50', type: 'text' });
      this.filterParams.bglx = ['DGZ', 'DQZ', 'YQZ', 'YGZ', 'YFB'];
    }
    // 待生成报告页面删除报告编号一栏
    if (_routerName === 'xfpgdsc') {
      this.tableColumn.splice(3, 1);
      this.filterParams.bglx = ['DSC'];
    }

    // 待签章报告页面删除报告编号一栏
    if (_routerName === 'xfpgdqz') {
      this.filterParams.bglx = ['DQZ'];
    }

    this.refreshSearch();
  },
  activated () {
    if (this.$route.params.isRefresh) {
      this.refreshSearch();
    }
  }
};
</script>
